<template>
    <UtilPanelContent>
        <template v-slot:utils>
            <isChallengeFunctionality v-if="stShowSettings">
                <Settings
                    :isChallengeFunctionality="true"
                    @close-settings="showSettings"
                    class="elevation-11 border-radius-1"
                />
            </isChallengeFunctionality>
            <v-bottom-sheet 
              v-model="questionsSheet"
              fullscreen
              >
              <v-sheet>
                <div v-show="stShowQuestions">
                    <Questions @close-question="openQuestion" class="" />
                </div>
              </v-sheet>
            </v-bottom-sheet>
            <isChallengeFunctionality v-if="stShowMusic">
                <Music
                    :isChallengeFunctionality="true"
                    @close-music="showMusic"
                    class="elevation-11 border-radius-1"
                />
            </isChallengeFunctionality>
            <div v-if="stShowDictionary">
                <Dictionary
                    @close-dictionary="openDictionary"
                    v-if="stShowDictionary"
                    class="elevation-11 border-radius-1"
                />
            </div>
            <!-- <div v-show="stShowReadaloud" transition="slide-x-transition">
                <ReadAloud @close-reading="showReadaloud" class="elevation-11 border-radius-1" />
            </div> -->
        </template>
        <div class="transition-all">
            <div class="d-flex flex-column justify-center align-center w-100">
                <div class="border-top w-100">
                    <v-btn
                        data-cy="utilsPanels-settings-button"
                        text
                        block
                        x-large
                        class="w-100 ma-0 py-6 d-flex justify-end align-center"
                        @click="
                            closeQuestion()
                            openSettingsSheetComponent()
                        "
                        ><div
                            class="d-flex flex-column justify-center align-end option--primary ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.settingTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.settingTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="settingImg" alt="settings"
                    /></v-btn>
                    <!-- <v-btn
                        data-cy="utilsPanels-questions-button"
                        text
                        block
                        x-large
                        :class="
                            'w-100 ma-0 py-6 d-flex justify-end align-center ' +
                            (hasQuestion ? 'animated infinite bounce delay-2s' : '')
                        "
                        @click="
                          openQuestion()"
                        id="btn-question"
                        ><div
                            class="d-flex flex-column justify-center align-end option--primary ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.questionsTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.questionsTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="questionsImg" alt="questions"
                    /></v-btn> -->
                </div>
                <div class="bottom-radius border-bottom w-100">
                    <v-btn
                        data-cy="utilsPanels-dictionary-button"
                        block
                        x-large
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center"
                        @click="
                            closeQuestion()
                            openDictionarySheetComponent()
                        "
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.dictionaryTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.dictionaryTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="dictionaryImg" alt="dictionary"
                    /></v-btn>
                    <v-btn
                        data-cy="utilsPanels-narrator-button"
                        block
                        x-large
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center"
                        @click="
                            closeQuestion()
                            openReadAloudSheetComponent()
                        "
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.readaloudTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.readaloudTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="readaloudImg" alt="readaloud"
                    /></v-btn>
                    <v-btn
                        data-cy="utilsPanels-music-button"
                        block
                        x-large
                        color="transparent"
                        elevation="0"
                        class="w-100 ma-0 border-radius-0 py-6 d-flex justify-end align-center"
                        @click="
                            closeQuestion()
                            openMusicSheetComponent()
                        "
                        ><div
                            class="d-flex flex-column justify-center align-end option--white ml-15 mr-2"
                            v-if="showTexts"
                        >
                            <span class="font-size-16 text-capitalize line-height-100">{{ texts.musicTxt.text }} </span>
                            <span class="font-size-10 text-capitalize"
                                >{{ texts.musicTxt.trl }}
                            </span>
                        </div>
                        <img class="reading-util-icon" :src="musicImg" alt="music"
                    /></v-btn>
                </div>
            </div>
        </div>

        <SettingsSheetVue ref="SettingsSheetComponent"></SettingsSheetVue>
        <DictionarySheet ref="DictionarySheetComponent"></DictionarySheet>
        <ReadAloudSheet ref="ReadAloudSheetComponent"></ReadAloudSheet>
        <MusicSheet is-challenge-functionality ref="MusicSheetComponent"></MusicSheet>
        <QuestionsSheet is-challenge ref="QuestionsSheetComponent"></QuestionsSheet>

    </UtilPanelContent>
</template>
<script>
/* eslint-disable global-require */
import { mapActions, mapState } from 'vuex'

import Music from '@/components/core/utils/Music.vue'
import UtilPanelContent from '@/components/core/utils/UtilPanelContent.vue'
import Dictionary from '@/components/core/utils/Dictionary.vue'
import ReadAloud from '@/components/core/utils/ReadAloud.vue'
import Settings from '@/components/core/utils/Settings.vue'
import Questions from './challengeUtils/Question.vue'

import SettingsSheetVue from '@/components/reading/content/SettingsSheet.vue'
import DictionarySheet from '@/components/reading/content/DictionarySheet.vue'
import ReadAloudSheet from '@/components/reading/content/ReadAloudSheet.vue'
import MusicSheet from '@/components/reading/content/MusicSheet.vue'
import QuestionsSheet from '@/components/reading/content/QuestionsSheet.vue'

export default {
    components: {
        Settings,
        Questions,
        Music,
        Dictionary,
        ReadAloud,
        UtilPanelContent,
        SettingsSheetVue,
        DictionarySheet,
        ReadAloudSheet,
        MusicSheet,
        QuestionsSheet,
    },
    data() {
        return {
            showTexts: true,
            isChallengeFunctionality: true,
            questionsSheet: false,
            indexImg: require('@/assets/img/icons/new-reading/index-purple.svg'),
            settingImg: require('@/assets/img/icons/new-reading/settings-purple.svg'),
            questionsImg: require('@/assets/img/icons/reading/3-questions.svg'),
            highlightingsImg: require('@/assets/img/icons/new-reading/highlighting-white.svg'),
            notesImg: require('@/assets/img/icons/new-reading/notes-white.svg'),
            dictionaryImg: require('@/assets/img/icons/new-reading/dictionary-white.svg'),
            readaloudImg: require('@/assets/img/icons/new-reading/read-aloud-white.svg'),
            musicImg: require('@/assets/img/icons/new-reading/music-white.svg'),
        }
    },
    methods: {
        ...mapActions('bookReading', [
            'showSettings',
            'showMusic',
            'showDictionary',
            'setDictionaryMode',
            'showReadaloud',
            'hideAllUtils',
        ]),
        ...mapActions('challenge', ['ShowQuestion', 'setReadingTime', 'setReReadingTime']),
        openDictionary() {
            this.setDictionaryMode('manual')
            this.showDictionary()
        },
        openQuestion() {
            this.hideAllUtils()
            this.ShowQuestion()
            if (this.isQuestionShowed) {
                this.setReadingTime(new Date().getTime() - this.tiempoEmpleadoLectura)
                if (this.tiempoEmpleadoReLectura !== 0) {
                    this.setReReadingTime(new Date().getTime() - this.tiempoEmpleadoReLectura)
                }
            } else {
                this.setReadingTime(new Date().getTime() + this.tiempoEmpleadoLectura)
                if (this.tiempoEmpleadoReLectura !== 0) {
                    this.setReReadingTime(new Date().getTime() + this.tiempoEmpleadoReLectura)
                }
            }
        },
        closeQuestion() {
            if (this.isQuestionShowed) this.ShowQuestion()
        },
        openQuestionsSheet(){
          this.questionsSheet = !this.questionsSheet
        },
        openSettingsSheetComponent() {
            this.showSettings()
            this.$root.$emit('utilsToggle', this.isChallengeFunctionality)
        },
        openDictionarySheetComponent() {
            this.openDictionary()
            this.$root.$emit('utilsToggle')
        },
        openReadAloudSheetComponent() {
            this.showReadaloud()
            this.$root.$emit('utilsToggle')
        },
        openMusicSheetComponent() {
            this.showMusic()
            this.$root.$emit('utilsToggle', this.isChallengeFunctionality)
        },
        closeQuestionsSheet() {
          this.bottomQuestionsSheet = false
        },
    },
    computed: {
        ...mapState({
            stShowIndex: (state) => state.bookReading.showIndex,
            stShowSettings: (state) => state.bookReading.showSettings,
            stShowQuestions: (state) => state.challenge.showQuestion,
            mobileShowQuestions: (state) => state.challenge.mobileShowQuestions,
            stShowHighlights: (state) => state.bookReading.showHighlights,
            stShowMusic: (state) => state.bookReading.showMusic,
            stShowDictionary: (state) => state.bookReading.showDictionary,
            stShowNotes: (state) => state.bookReading.showNotes,
            stShowReadaloud: (state) => state.bookReading.showReadaloud,
            hasQuestion: (state) => state.bookReading.hasQuestion,
            tiempoEmpleadoLectura: (state) => state.challenge.tiempoEmpleadoLectura,
            tiempoEmpleadoReLectura: (state) => state.challenge.tiempoEmpleadoReLectura,
        }),
        isQuestionShowed() {
            return this.stShowQuestions || this.mobileShowQuestions
        },
        texts() {
            return {
                indexTxt: {
                    text: this.$t('bookReading.index'),
                    trl: this.$i18n.locale === 'es' ? 'Index' : 'Índice',
                },
                settingTxt: {
                    text: this.$t('bookReading.settings'),
                    trl: this.$i18n.locale === 'es' ? 'Settings' : 'Ajustes',
                },
                questionsTxt: {
                    text: this.$t('bookReading.question'),
                    trl: this.$i18n.locale === 'es' ? 'Questions' : 'Preguntas',
                },
                highlightingsTxt: {
                    text: this.$t('bookReading.marker'),
                    trl: this.$i18n.locale === 'es' ? 'Highlighting' : 'Marcadores',
                },
                notesTxt: {
                    text: this.$t('bookReading.notes'),
                    trl: this.$i18n.locale === 'es' ? 'Notes' : 'Notas',
                },
                dictionaryTxt: {
                    text: this.$t('bookReading.dictionary'),
                    trl: this.$i18n.locale === 'es' ? 'Dictionary' : 'Diccionario',
                },
                readaloudTxt: {
                    text: this.$t('bookReading.storyletter'),
                    trl: this.$i18n.locale === 'es' ? 'Read Aloud' : 'Narrador',
                },
                musicTxt: {
                    text: this.$t('bookReading.music'),
                    trl: this.$i18n.locale === 'es' ? 'Music' : 'Música',
                },
            }
        },
    },
    mounted(){
      this.$root.$on('closeQuestionsSheet', this.closeQuestionsSheet)
    },
    beforeDestroy() {
      this.$root.$off('closeQuestionsSheet', this.closeQuestionsSheet)
    },
}
</script>

<style lang="scss" scoped>
.bg-purple {
    background: rgba(81, 69, 133, 1);
    border: 1.5px solid #514773;
}
.option--primary {
    color: #514773;
}
.option--white {
    color: white;
}
.util-bar{
    z-index: 5;
    .v-btn{
        span:first-of-type{
            font-weight: 600;
        }
    }
    .v-btn:not(.v-btn--round).v-size--x-large{
        height: 60px;
    }
}

// .util-bar-text {
//     width: 12.5em !important;
// }

.util-bar-non-text {
    width: 3.5em;
}
.util-bar-border {
    border-radius: 1vh;
}

.bottom-radius {
    border-radius: 0 0 1vh 1vh !important;
}

.border-top {
    background: white;
}
.border-bottom {
    border: 1.5px solid rgba(81, 69, 133, 1) !important;
    background: rgba(81, 69, 133, 1);
}

.content-shadow {
    box-shadow: 0 6px 7px -4px rgba(0, 0, 0, 0.2), 0 11px 15px 1px rgba(0, 0, 0, 0.14),
        0 4px 20px 3px rgba(0, 0, 0, 0.12) !important;
}

/* Medium devices (landscape tablets, 768px and up) */
// @media only screen and (min-width: 768px) {
//     .reading-util-icon {
//         width: 2.5vh;
//     }

//     .util-bar {
//         right: 6em;
//         top: 5rem;
//     }
// }

/* Large devices (laptops/desktops, 992px and up) */
// @media only screen and (min-width: 992px) {
//     .reading-util-icon {
//         width: 2.5vh;
//     }
//     .util-bar {
//         right: 8em;
//         top: 5rem;
//     }
// }

/* Extra large devices (large laptops and desktops, 1200px and up) */
// @media only screen and (min-width: 1200px) {
//     .reading-util-icon {
//         width: 3vh;
//     }
//     .util-bar {
//         right: 10em;
//         top: 5rem;
//     }
// }
</style>
